<template>
  <input-base
      ref="input"
      :validated-field="validatedField"
      :field-config="fieldConfig"
      :read-only="readOnly"
      :editor-mode="editorMode"
  >
    <template slot="editor">
      <text-pills-list
          class="mb-0 w-100"
          ref="input"
          v-model="validatedField.value"
          :read-only="readOnly"
          :items="validatedField.value"
          :separators="separators"
          :pattern="pattern"
      ></text-pills-list>
    </template>

  </input-base>
</template>


<script>

import FormValidatedField from "@/components/forms/FormValidatedField";
import SelectFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig";
import TextPillsList from "@/components/inputs/controls/TextPillsList";
import InputBase from "@/components/inputs/InputBase";
import TextListFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/TextListFormFieldConfig";

export default {
  name: "TextPillsListRenderer",
  components: {TextPillsList, InputBase},
  created() {
    this.valChange(this.validatedField?.value);
  },

  mounted() {
    if (this.fieldConfig.autofocus) {
      setTimeout(() => this.afterMounted());
    }
  },
  props: {
    validatedField: {type: FormValidatedField, required: true},
    fieldConfig: {type: TextListFormFieldConfig, required: true}
  },

  methods: {
    setReadOnly(readOnly) {
      this.readOnly = this.fieldConfig.readOnly || readOnly;
    },
    setEditorMode(val) {
      this.editorMode = val;
    },

    afterMounted() {
      this.$refs.input?.focus();
    },

    focusIn() {
    },
    focusOut() {
      this.validatedField?.validate();
    },
    valChange(val) {
      if (this.fieldConfig.separators !== null) {
        this.separators = new RegExp(this.fieldConfig.separators);
      } else {
        this.separators = / |;|,|\\t/;
      }
      if (this.fieldConfig.pattern !== null) {
        this.pattern = new RegExp(this.fieldConfig.pattern);
      } else {
        this.pattern = /.*/;
      }
    }

  },
  watch: {
    'validatedField': function (val) {
      this.valChange(val.value);
    },
    'validatedField.value': function (val) {
      this.valChange(val);
    },
  },

  data: () => ({
    separators: {type: RegExp, default: () => / |;|,|\\t/},
    pattern: {type: RegExp, default: () => /.*/},
    readOnly: true,
    editorMode: false,
    pillsValid: true
  })
}
</script>

<style scoped>

</style>